import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'

import { bonusEngineSelector } from '@/state/bonus-engine/slices/index.slices'
import InputFormikAutocomplete from '@/views/components/input-formik-autocomplete/index.component'
import { PlayerUsernameComponent } from './player.component'

export const ByCodeTriggerFormComponent = () => {
  const { t } = useTranslation()

  const { bonusNames } = useSelector(bonusEngineSelector)

  return (
    <Grid container spacing={1}>
      <PlayerUsernameComponent />
      <Grid item xs={12}>
        <InputFormikAutocomplete
          name="bonusCode"
          label={t('labels.bonusName')}
          options={bonusNames || []}
          getOptionLabel={(option: { name: string; code: string }) =>
            option.name ? `${option.name} - (${option.code})` : ''
          }
          isOptionEqualToValue={(option, value) => value.code === option.code}
          limitTags={2}
          chipTags
        />
      </Grid>
    </Grid>
  )
}
